import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const MuteIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#FDFBF9"
      d="m19.036 21.508-3.037-3.037c-.26.165-.525.31-.796.433-.27.124-.552.235-.844.332v-.97c.17-.065.338-.133.505-.204.167-.072.326-.155.477-.248l-3.675-3.675v3.223l-3.453-3.454H4.866v-3.816H7.62L2.76 5.231l.661-.662 16.277 16.277-.661.662Zm-.885-4.935-.65-.65a6.736 6.736 0 0 0 .96-1.836c.23-.668.344-1.371.344-2.109a6.47 6.47 0 0 0-1.223-3.837 6.65 6.65 0 0 0-3.223-2.448V4.72c1.59.54 2.882 1.468 3.877 2.788a7.236 7.236 0 0 1 1.492 4.47c0 .857-.14 1.675-.419 2.453a7.967 7.967 0 0 1-1.158 2.142ZM15.578 14l-1.22-1.22V8.72c.558.356.99.825 1.3 1.407A3.94 3.94 0 0 1 16.12 12a4 4 0 0 1-.135 1.046c-.09.335-.226.653-.407.954Zm-3.912-3.911L9.951 8.354l1.715-1.715v3.45Zm-.923 5.033v-1.906l-2.2-2.2H5.79v1.969h2.803l2.15 2.137Z"
    />
  </Svg>
)
export default MuteIcon
